module.exports = __webpack_public_path__ + "img/home_small.4ba1b54c.svg";